import { handle400Statuses, sendApiRequest } from './api';
import { docsActionTypes } from '@constants/actionTypes';
import { logNetRequest } from '@utils/usefulFuncs';

export const fetchMacroDocs = () => {
  return async (dispatch) => {
    const response = await sendApiRequest('get', 'v1/genai_tickers_filenames?topic=macro', null, null);
    const { status, data } = response;
    handle400Statuses(status);
    if (status === 200 && data && typeof data === 'object') {
      const macroDocs = data['0_FED'] || [];
      if (Array.isArray(macroDocs)) {
        dispatch({
          type: docsActionTypes.setMacroDocs,
          payload: macroDocs,
        });
      }
    }
    return response;
  };
};

export async function fetchTagData(id) {
  const URL = `v1/genai/documents/tags?doc_tag_id=${id}`;
  const { status, data, error } = await sendApiRequest('get', URL);
  logNetRequest(URL, status, data);
  handle400Statuses(status);
  if (status === 200) {
    return { ok: true, data: data[0] };
  }
  return { status, error };
}

export const fetchDocs = async (params = '') => {
  const URL = `v1/genai/documents${params}`;
  const { status, data, error } = await sendApiRequest('get', URL);
  handle400Statuses(status);
  logNetRequest(URL, status, data);
  if (status === 200) {
    const docs = data.documents;
    return docs;
  } else {
    console.error('Error fetching docs', error);
    return null;
  }
};
